import React from "react"
import useMediaQuery from "../../../shared/utils/useMediaQuery.js"
import GenericModal from "../../../shared/components/modals/generic-modal/generic-modal.jsx"
import Button from "../../../shared/components/atoms/button/button"
import { siteUrl } from "../../../shared/utils/siteUrl"
import "./modal-user-exists.scss"

const ModalUserExists = ({ setModalActive, title, subDescription, description }) => {
  const closeModal = () => {
    setModalActive(null)
  }

  const redirectToLogin = () => {
    window.location.href = siteUrl + "/login"
  }

  return (
    <GenericModal>
      <div className="f-container-modal">
        {
          <i
            className="far fa-times f-container-modal__close-icon"
            onClick={closeModal}
          >
            X
          </i>
        }
        {title && <h1 className="f-container-modal__title">{title}</h1>}
       
        {description && (
          <p className="f-container-modal__description">{ description }</p>
        )}
        {subDescription && <h3 className="f-container-modal__subDescription">{subDescription}</h3>}
        
        <div className="f-container-modal__buttons">
          <Button
            className="new-primary-pink small f-btn"
            onClick={redirectToLogin}
            title="Iniciar Sesión"
            type="submit"
          />
        </div>
      </div>
    </GenericModal>
  )
}

export default ModalUserExists
